import { ChangeEventHandler, KeyboardEventHandler, useRef, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

// shared
import CorePrimaryButton from 'shared/button/CorePrimaryButton';

// components
import LoginInput from '../../components/login/LoginInput';
import {
	Body,
	BodyDesc,
	BodyFooter,
	BodyTitle,
	BodyTitleGroup,
	InputForm,
	ForgotText,
} from './style';
import { useSendPasswordEmailMutation } from 'hooks/mutations/user';
import useToast from 'hooks/useToast';

const PasswordAssistance = () => {
	const toast = useToast();

	const [email, setEmail] = useState('');
	const [sent, setSent] = useState(false);

	const btn_ref = useRef<HTMLButtonElement>(null);

	const { mutate: emailMutate, isLoading: email_loading } =
		useSendPasswordEmailMutation();

	const text_mapper = [
		{ title: '비밀번호 찾기', desc: '가입된 아이디 이메일 주소를 입력해 주세요.' },
		{
			title: '전송 완료',
			desc: (
				<>
					해당 이메일로 비밀번호 초기화 링크를 전송했습니다.
					<br />
					이메일 링크로 비밀번호를 재설정하시기 바랍니다.
				</>
			),
		},
	];

	const emailChange: ChangeEventHandler<HTMLInputElement> = (e) => {
		setEmail(e.currentTarget.value);
	};

	const sendEmail = () => {
		emailMutate(email, {
			onSuccess() {
				setSent(true);
				toast('이메일이 전송되었습니다.');
			},
			onError(err) {
				console.log(err);
				if (err.resultCode === 'workspace_not_found')
					toast(
						'죄송합니다. 이 이메일 주소를 사용하는 계정을 찾을 수 없습니다. 다시 시도하거나 새로운 계정을 등록하세요.' +
							'\n' +
							'지속적인 로그인 오류 시 인플루언서 마케팅팀 김성욱 프로(edwins.kim@samsung.com)에게 메일로 연락주세요.',
						false,
						true,
					);
				else
					toast(
						'이메일 전송에 실패했습니다.' +
							'\n' +
							'지속적인 로그인 오류 시 인플루언서 마케팅팀 김성욱 프로(edwins.kim@samsung.com)에게 메일로 연락주세요.',
						false,
						true,
					);
			},
		});
	};

	const enterEvent: KeyboardEventHandler<HTMLInputElement> = (e) => {
		if (e.key !== 'Enter' || btn_ref.current === null) return;

		btn_ref.current.click();
	};

	return (
		<Body>
			<BodyTitleGroup>
				<BodyTitle>{text_mapper[Number(sent)].title}</BodyTitle>
				<BodyDesc>{text_mapper[Number(sent)].desc}</BodyDesc>
			</BodyTitleGroup>

			{!sent && (
				<InputForm>
					<LoginInput
						_placeholder="E-mail"
						input_id="assistance-email"
						_value={email}
						_onChange={emailChange}
						_onKeyDown={enterEvent}
					/>
				</InputForm>
			)}

			<BodyFooter>
				{!sent && (
					<CorePrimaryButton
						size="large"
						style_type="filled"
						text="비밀번호 초기화"
						_onClick={sendEmail}
						is_loading={email_loading}
						_ref={btn_ref}
					/>
				)}

				<Link to="/imms/login">
					<PrevText>{'<'} 이전</PrevText>
				</Link>
			</BodyFooter>
		</Body>
	);
};

const PrevText = styled(ForgotText)`
	text-align: left;
	text-decoration: none;
`;

export default PasswordAssistance;
